import React, { useCallback, useRef, useState } from 'react';
import { Skeleton, message } from 'antd';
import styled from '@emotion/styled';
import useSWR from 'swr';
import { PER_PAGE_OTHER } from '../../../constants/common';
import { appStyles } from '../../../styles';
import { MESSAGE_ERROR } from '../../../constants/message';
import { PlayerProfileHeader } from '../../organisms/player-coach/PlayerProfileHeader';
import { PlayerProfileTable } from '../../organisms/player-coach/PlayerProfileTable';
import { CoachProfileHeader } from '../../organisms/player-coach/CoachProfileHeader';
import { CoachProfileTable } from '../../organisms/player-coach/CoachProfileTable';
import { FormCoachProfileModal } from '../../organisms/player-coach/FormCoachProfileModal';
import {
  getPlayerProfileListRepository,
  getCoachProfileListRepository,
} from '../../../repository/mytm/coach-profile/coachProfileRepository';

export const PlayerCoachProfile = () => {
  const [pageActive, setPageActive] = useState(1);
  const [pageActiveCoach, setPageActiveCoach] = useState(1);
  const [loading] = useState(false);
  const [loadingCoach] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [record, setDataRecord] = useState<any>();
  const errorCount = useRef(0);
  const [countrySelected] = useState('USA');

  const { data, isValidating, error, mutate } = useSWR(
    [pageActive, 1, countrySelected],
    () =>
      getPlayerProfileListRepository({
        country: countrySelected,
      }),
    {
      revalidateOnFocus: false,
      refreshInterval: 600000,
    },
  );

  const coachProfileData = useSWR(
    [pageActiveCoach, countrySelected],
    (pageNumber: number) =>
      getCoachProfileListRepository({
        country: countrySelected,
        page: pageNumber,
        take: PER_PAGE_OTHER,
        sort: true,
      }),
    {
      revalidateOnFocus: false,
      refreshInterval: 600000,
    },
  );

  const onCloseModal = useCallback(() => {
    setIsOpenModal(false);
    setDataRecord(null);
  }, []);

  const handleChangePageActiveCoach = useCallback(value => {
    setPageActiveCoach(value);
    window.scrollTo(100, 0);
  }, []);

  const handleChangePageActive = useCallback(value => {
    setPageActive(value);
    window.scrollTo(0, 0);
  }, []);

  if (error || coachProfileData.error) {
    errorCount.current += 1;
    if (errorCount.current === 1) {
      message.error(MESSAGE_ERROR.M02);
      const timeout = setTimeout(() => {
        errorCount.current = 0;
        clearTimeout(timeout);
      }, 5000);
    }
  }
  const recordPlayer = data?.widgets?.map((item: any, index: number) => ({ ...item, ...{ index } }));
  const recordCoachProfiles = coachProfileData?.data?.coachProfiles?.map((item: any, index: number) => ({
    ...item,
    ...{ index },
  }));

  return (
    <Container>
      <PlayerProfileHeader />
      {!data && (
        <Container>
          <Skeleton active />
        </Container>
      )}
      {data && (
        <PlayerProfileTable
          handleChangePageActive={handleChangePageActive}
          onRefresh={mutate}
          records={recordPlayer || []}
          loading={loading || isValidating}
          pagination={{
            onChange: handleChangePageActive,
            pageSize: PER_PAGE_OTHER,
            current: pageActive,
            total: data?.total,
          }}
        />
      )}

      <CoachProfileHeader setIsOpenModal={setIsOpenModal} />
      {!coachProfileData.data && (
        <Container>
          <Skeleton active />
        </Container>
      )}
      {coachProfileData.data && (
        <CoachProfileTable
          handleChangePageActive={handleChangePageActiveCoach}
          onRefresh={coachProfileData?.mutate}
          records={recordCoachProfiles || []}
          loading={loadingCoach || coachProfileData?.isValidating}
          setIsOpenModal={setIsOpenModal}
          setDataRecord={setDataRecord}
          pagination={{
            onChange: handleChangePageActiveCoach,
            pageSize: PER_PAGE_OTHER,
            current: pageActiveCoach,
            total: coachProfileData?.data?.total,
          }}
        />
      )}

      {isOpenModal && (
        <FormCoachProfileModal
          setDataRecord={setDataRecord}
          record={record}
          onRefresh={coachProfileData?.mutate}
          isOpenModal={isOpenModal}
          onClose={onCloseModal}
          countrySelected={countrySelected}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}

  & .ant-pagination {
    float: right;
    padding: 15px 0 0 0;
  }

  .ant-table-thead {
    border-bottom: 2px solid #eee;
  }
  .ant-table-thead > tr > th {
    ${appStyles.background.tableBgGray}
    text-transform: uppercase;
    font-size: 0.75rem;
    font-weight: 600;
    &:before {
      display: none;
    }
  }

  & .ant-page-header {
    padding-left: 0px;
  }
`;
